// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyResults_container__TX05g","description":"EmptyResults_description__zf9Yx","resetFilterButton":"EmptyResults_resetFilterButton__NBNhN"};